
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investing/hala/[id]",
      function () {
        return require("private-next-pages/investing/hala/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investing/hala/[id]"])
      });
    }
  